'use client'

import { useEffect, useState } from 'react'
import { hasConsentChoice, setAnalyticsConsent } from '@/src/lib/appInsights'

export function ConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Only show banner if user hasn't made a choice yet
    if (!hasConsentChoice()) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    setAnalyticsConsent(true)
    setVisible(false)
  }

  const handleDecline = () => {
    setAnalyticsConsent(false)
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed right-0 bottom-0 left-0 z-50 border-t border-gray-200 bg-white px-4 py-4 shadow-lg sm:px-6">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-4 sm:flex-row sm:justify-between">
        <p className="text-sm text-gray-700">
          Utilizamos cookies e tecnologias semelhantes para melhorar sua experiencia e analisar o uso
          do portal. Ao aceitar, voce concorda com a coleta de dados de navegacao conforme nossa
          politica de privacidade (LGPD).
        </p>
        <div className="flex shrink-0 gap-3">
          <button
            onClick={handleDecline}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
          >
            Recusar
          </button>
          <button
            onClick={handleAccept}
            className="rounded-md bg-purple-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-purple-700"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  )
}
